import {
  ALL_QUOTE_FULL_PATH,
  ALL_QUOTES_PATH,
  CUSTOMER_ID_SUB_PATH,
  CUSTOMER_PROFILE_PATH,
  hasRequiredPermission,
  MY_QUOTE_FULL_PATH,
  MY_QUOTES_PATH,
  PERMISSIONS,
  SPEC_SUB_PATH
} from '@common/utils'
import { useTranslation } from 'react-i18next'
import { useLocation, useParams } from 'react-router-dom'

export const useHandleUrlAroundQuotesType = () => {
  const { t } = useTranslation('', { keyPrefix: 'common' })

  const { id: customerId } = useParams()

  const location = useLocation()

  const isSalesManager = !hasRequiredPermission(PERMISSIONS.ALL_QUOTES)
  const isAllQuotes = location.pathname.includes('all-quotes')
  const showAllQuotesInBreadcrumb = isAllQuotes && !isSalesManager

  const isSpecsBuilder = location.pathname.includes(CUSTOMER_PROFILE_PATH)

  const specTemplatePath = `${CUSTOMER_PROFILE_PATH}/${CUSTOMER_ID_SUB_PATH}/${customerId}/customer-spec/${SPEC_SUB_PATH}/`

  let baseFullPath = showAllQuotesInBreadcrumb
    ? ALL_QUOTE_FULL_PATH
    : MY_QUOTE_FULL_PATH

  const baseRegularPath = showAllQuotesInBreadcrumb
    ? ALL_QUOTES_PATH
    : MY_QUOTES_PATH

  const breadcrumbBaseLabel = showAllQuotesInBreadcrumb
    ? t('allQuotes')
    : t('myQuotes')

  if (isSpecsBuilder) {
    baseFullPath = specTemplatePath
  }

  return {
    baseFullPath,
    baseRegularPath,
    breadcrumbBaseLabel,
    showAllQuotesInBreadcrumb
  }
}
